export default __webpack_public_path__ + "static/media/wallet.522f5e82.svg";